module.exports = __webpack_public_path__ + "static/media/reward-card-right.9c358784.svg";